import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzIconModule, NZ_ICONS } from 'ng-zorro-antd/icon';
import * as antIcons from '@ant-design/icons-angular/icons';
import { IconDefinition } from '@ant-design/icons-angular';

import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzModalModule } from 'ng-zorro-antd/modal';

import { NzLayoutModule } from 'ng-zorro-antd/layout';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzStatisticModule } from 'ng-zorro-antd/statistic';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzResultModule } from 'ng-zorro-antd/result';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzStepsModule } from 'ng-zorro-antd/steps';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzUploadModule } from 'ng-zorro-antd/upload';

const Modules = [
  NzGridModule,
  NzCollapseModule,
  NzListModule,
  NzResultModule,
  NzTabsModule,
  NzStepsModule,
  FormsModule,
  ReactiveFormsModule,
  NzSpaceModule,
  NzLayoutModule,
  NzButtonModule,
  NzCheckboxModule,
  NzRadioModule,
  NzInputModule,
  NzInputNumberModule,
  NzIconModule,
  NzSelectModule,
  NzDatePickerModule,
  NzDrawerModule,
  NzSpaceModule,
  NzNotificationModule,
  NzTableModule,
  NzToolTipModule,
  NzSpinModule,
  NzFormModule,
  NzAutocompleteModule,
  NzDividerModule,
  NzEmptyModule,
  NzPageHeaderModule,
  NzDescriptionsModule,
  NzAffixModule,
  NzTagModule,
  NzCardModule,
  NzProgressModule,
  NzStatisticModule,
  NzModalModule,
  NzMenuModule,
  NzPopconfirmModule,
  NzDropDownModule,
  NzBadgeModule,
  NzAvatarModule,
  NzMessageModule,
  NzAlertModule,
  NzUploadModule
];

const icons: IconDefinition[] = [
  antIcons.EyeTwoTone,
  antIcons.EyeInvisibleOutline,
  antIcons.EditTwoTone,
  antIcons.BellOutline,
  antIcons.LockTwoTone,
  antIcons.DeleteTwoTone,
  antIcons.LinkOutline,
  antIcons.PlusCircleFill,
  antIcons.CloseCircleTwoTone,
  antIcons.CheckCircleTwoTone,
  antIcons.ShoppingOutline,
  antIcons.DeleteOutline,
  antIcons.CodeSandboxOutline,
  antIcons.ReloadOutline,
  antIcons.LockOutline,
  antIcons.UserOutline,
  antIcons.SafetyCertificateOutline,
  antIcons.SafetyCertificateFill,
  antIcons.StopTwoTone,
  antIcons.StopOutline,
  antIcons.PauseOutline,
  antIcons.PauseCircleOutline,
  antIcons.PauseCircleFill,
  antIcons.PauseCircleTwoTone,
  antIcons.MinusCircleOutline,
  antIcons.PlusOutline,
  antIcons.PlusSquareOutline,
  antIcons.MinusSquareOutline,
  antIcons.ShareAltOutline,
  antIcons.MoreOutline,
  antIcons.ExportOutline,
  antIcons.CommentOutline,
  antIcons.QuestionCircleOutline,
  antIcons.ReloadOutline,
  antIcons.VerticalAlignTopOutline,
  antIcons.VerticalAlignMiddleOutline,
  antIcons.VerticalAlignBottomOutline,
  antIcons.FullscreenOutline,
  antIcons.FullscreenExitOutline,
  antIcons.MessageOutline,
  antIcons.DownloadOutline,
  antIcons.SearchOutline,
  antIcons.CloseOutline,
  antIcons.ClearOutline,
  antIcons.InboxOutline,
  antIcons.PhoneOutline,
  antIcons.InboxOutline,
  // Icons used by the shared Workflow Run Details view (libs/ui)
  antIcons.CloseCircleOutline,
  antIcons.InfoCircleOutline,
  antIcons.ExclamationCircleOutline,
  antIcons.CodeOutline,
  antIcons.DeploymentUnitOutline,
  antIcons.LoadingOutline
];
@NgModule({
  imports: Modules,
  exports: Modules,
  providers: [
    { provide: NZ_ICONS, useValue: icons },
    { provide: NZ_I18N, useValue: en_US }
  ]
})
export class AdminAngularAntdModule {}
